var $96673b78dbaf44b6$exports = {};
$96673b78dbaf44b6$exports = {
    "loading": `\u{8AAD}\u{307F}\u{8FBC}\u{307F}\u{4E2D}...`,
    "placeholder": `\u{9078}\u{629E}\u{2026}`
};


export {$96673b78dbaf44b6$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
